import Navbar from "./Components/Navbar/Navbar";
import WishlistProvider from "./Context/WishlistContext";
import WishlistPanel from "./Components/Wishlist/WishlistPanel";
import MobileBottomNav from "./Components/MobileBottomNav/MobileBottomNav";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { applyTheme } from "./utils/theme";
import ScrollToTop from "./Components/ScrollTop/ScrollTop";
import Shop from "./Pages/Shop";
import Cart from "./Pages/Cart";
import Product from "./Pages/Product";
import ShopCategory from "./Pages/ShopCategory";
import Footer from "./Components/Footer/Footer";
import LoginSignup from "./Pages/LoginSignup";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import { useState } from "react";
import HeaderTitle from "./Components/HederTitle/HeaderTitle";
import Bulk from "./Components/Bulk/Bulk";
import ExplorerIdeas from "./Pages/ExplorerIdeas";
import SearchResults from "./Components/Search/SearchResults";
import AddReview from "./Components/CustomerReviews/AddReview";
import UserDetails from "./Pages/UserDetails";
import TrackOrder from "./Pages/TrackOrder";
import ComingSoon from "./Pages/ComingSoon";
import TermsAndConditions from "./Components/Info/TermsAndConditions";
import ShippingPolicy from "./Components/Info/ShippingPolicy";
import RefundPolicy from "./Components/Info/RefundPolicy";
import PrivacyPolicy from "./Components/Info/PrivacyPolicy";
import WashCareInstructions from "./Components/Info/WashCareInstructions";
import AboutUs from "./Components/About/About-us";
import ReviewsPage from "./Components/Customer/ReviewPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChatBot from "./Components/ChatBot/ChatBot";
import { useHideNearFooter } from "./utils/useHideNearFooter";
import { useIsScrolling } from "./utils/useIsScrolling";

// dev (npm start) uses the local backend; production build uses the live API
export const backend_url =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4000"
    : "https://api.aavryaafabhub.com";
export const currency = "₹";

export const MainaLayout = () => {
  const location = useLocation();
  const [searchResults, setSearchResults] = useState([]);
  const isCheckoutFlow = location.pathname === "/cart" || location.pathname === "/checkout";

  useEffect(() => {
    setSearchResults([]);
  }, [location.pathname]);

  return (
    <div>
      <Navbar setSearchResults={setSearchResults} />
      <div className="md:min-h-[calc(100vh-428px)] mt-[20px] max-md:pb-[calc(64px+env(safe-area-inset-bottom))]">
        {searchResults.length > 0 ? (
          <SearchResults
            results={searchResults}
            setSearchResults={setSearchResults}
          />
        ) : (
          <Outlet />
        )}
      </div>
      {/* Upsell banner clashes with the cart/checkout sticky CTA bar and
          floating help buttons, so it's skipped on that flow. */}
      {!isCheckoutFlow && <Bulk />}
      <Footer />
      <MobileBottomNav />
    </div>
  );
};

// Docked just above the mobile bottom tab bar (see .floating-contact in
// index.css) rather than floating over page content. Hidden entirely on
// cart/checkout, where the sticky checkout bar already occupies that band.
const FloatingContactButtons = () => {
  const [showContactOptions, setShowContactOptions] = useState(false);
  const nearFooter = useHideNearFooter();
  const isScrolling = useIsScrolling();
  const location = useLocation();
  const isCheckoutFlow = location.pathname === "/cart" || location.pathname === "/checkout";

  if (nearFooter || isCheckoutFlow) return null;

  return (
    <div
      className="floating-contact"
      style={
        isScrolling && !showContactOptions
          ? { opacity: 0.35, transform: "scale(0.85)", transition: "opacity 0.2s, transform 0.2s" }
          : { opacity: 1, transform: "scale(1)", transition: "opacity 0.2s, transform 0.2s" }
      }
    >
      {showContactOptions && (
        <>
          <a
            href="https://wa.me/919789389489"
            className="contact-option whatsapp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp size={25} />
          </a>
          <a href="tel:9789389489" className="contact-option call">
            <FaPhoneAlt size={25} />
          </a>
        </>
      )}
      <button
        className="contact-toggle"
        onClick={() => setShowContactOptions(!showContactOptions)}
      >
        <FaWhatsapp size={25} />
      </button>
    </div>
  );
};

function App() {
  useEffect(() => {
    fetch(`${backend_url}/api/settings`)
      .then((r) => r.json())
      .then((d) => {
        if (d.success && d.settings?.theme) applyTheme(d.settings.theme);
      })
      .catch(() => {});
  }, []);

  return (
    <WishlistProvider>
    <div>
      <Router>
        <ToastContainer position="top-center" autoClose={2500} />
        <WishlistPanel />
        <ScrollToTop />
        <Routes>
          <Route element={<MainaLayout />}>
            <Route path="/home" element={<Shop gender="all" />} />
            <Route path="/product" element={<Product />}>
              <Route path=":productId/:productName" element={<Product />} />
            </Route>
            <Route path="/add-review/:id" element={<AddReview />} />
            <Route
              path="/collections/:subcategory"
              element={<ShopCategory category="new-arrivals" />}
            />
            <Route path="/cart" element={<Cart />} />
            <Route path="/login" element={<LoginSignup />} />
            <Route path="/summa" element={<HeaderTitle />} />
            <Route path="/explore-our-ideas" element={<ExplorerIdeas />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/user-profile" element={<UserDetails />} />
            <Route path="/track" element={<TrackOrder />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/shipping-policy" element={<ShippingPolicy />} />
            <Route path="/wash-care-instructions" element={<WashCareInstructions />} />
            <Route path="/terms-conditions" element={<TermsAndConditions />} />
            <Route path="/checkout" element={<Cart />} />
            <Route path="/reviews" element={<ReviewsPage />} />
          </Route>
          {/* Standalone full-screen pages (no navbar/footer). The real site
              is fully live and browsable at /home — "/" is the public
              default for now while launch is pending. */}
          <Route path="/" element={<ComingSoon />} />
          <Route path="/launching-soon" element={<ComingSoon />} />
        </Routes>

        <FloatingContactButtons />

        <ChatBot />
      </Router>
    </div>
    </WishlistProvider>
  );
}

export default App;
